var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sh-skeleton"},[_c('skeleton-loading',_vm._l((6),function(item){return _c('row',{key:item,attrs:{"justify":"space-between"}},[_c('column',{attrs:{"span":12}},[_c('square-skeleton',{attrs:{"boxProperties":{
            top: '10px',
            bottom: '10px',
            height: '25px'
          }}})],1),_c('column',{attrs:{"span":4,"gutter":10}},[_c('circle-skeleton')],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }